import React from "react";
import "./ContentTile.css";
import {Link} from "react-router-dom";
import {useIntl} from "react-intl";
import Image from "./Image";
import {AppLocationState} from "../logic/APITypes";

export type ContentTileProps = {
  name: string;
  description: string;
  /** A click element that can either be a link or a button */
  clickElement?: JSX.Element;
  /** Additional content that can be added next to the link button of the content tile */
  additionalInfo?: JSX.Element;
  /** An image that can be added next to the name of the content tile */
  image?: string;
  /** If provided, the header section of the content tile will be a link to an internal page */
  internalLink?: {to: string; state: AppLocationState};
};
/** A content tile for summarizing content and providing a link*/
function ContentTile({
  name,
  description,
  clickElement,
  additionalInfo,
  image,
  internalLink,
}: ContentTileProps) {
  const {formatMessage} = useIntl();
  const headerContent = (
    <>
      {image && (
        <Image
          src={image}
          width={32}
          height={32}
          alt={formatMessage({id: "general.logo.alt"}, {name: name})}
        />
      )}
      <div className="contentTile__info">
        <p className="contentTile__name">{name}</p>
        <p className="contentTile__description">{description}</p>
      </div>
    </>
  );

  return (
    <div id={`contentTile_${name}`} className="contentTile">
      {internalLink ? (
        <Link
          className="contentTile__header"
          {...internalLink}
          aria-label={formatMessage(
            {id: "general.link.ariaLabel.internal"},
            {name: name},
          )}
        >
          {headerContent}
        </Link>
      ) : (
        <div className="contentTile__header">{headerContent}</div>
      )}
      <div className="contentTile__divider" />
      <div
        className={`contentTile__footer ${additionalInfo ? "contentTile__footer--withInfo" : ""}`}
      >
        {additionalInfo}
        {clickElement}
      </div>
    </div>
  );
}

export default ContentTile;
